import React, { useEffect, useState } from "react";
import { adminApi } from "@/api/adminOneClient";

const STATUSES = ["", "open", "reviewed", "dismissed", "escalated"];

export default function AdminCompliance() {
  const [status, setStatus] = useState("");
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try { const { data } = await adminApi.complianceFlags(status || undefined); setRows(data?.flags || []); }
    finally { setBusy(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [status]);

  const patch = async (id, newStatus) => {
    try { await adminApi.patchComplianceFlag(id, { status: newStatus }); await load(); } catch {}
  };

  return (
    <div className="admin-page" data-testid="admin-compliance">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Compliance Center</h2>
        <div className="admin-filters">
          <select value={status} onChange={(e)=>setStatus(e.target.value)}>{STATUSES.map(s=><option key={s} value={s}>{s||"Any status"}</option>)}</select>
          <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} disabled={busy}>{busy?"…":"↻ Refresh"}</button>
        </div>
      </div>
      <table className="admin-table">
        <thead><tr><th>Created</th><th>Mode</th><th>Asset</th><th>Verdict</th><th>Risk</th><th>Flags</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          {rows.map((r,i)=>(
            <tr key={r.id || i}>
              <td>{r.created_at && new Date(r.created_at).toLocaleString()}</td>
              <td><span className="rc-pill">{(r.mode||"").toUpperCase()}</span></td>
              <td>{r.metadata?.asset_or_event || "—"}</td>
              <td><b>{r.metadata?.verdict || "—"}</b></td>
              <td>{r.metadata?.risk_level || "—"}</td>
              <td>{(r.metadata?.compliance_flags || []).join(", ") || "—"}</td>
              <td><span className={`rc-pill compliance-pill compliance-pill--${(r.status||"open").toLowerCase()}`}>{(r.status||"open").toUpperCase()}</span></td>
              <td style={{whiteSpace:"nowrap"}}>
                <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={()=>patch(r.id,"reviewed")}>Review</button>
                <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={()=>patch(r.id,"escalated")}>Escalate</button>
                <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={()=>patch(r.id,"dismissed")}>Dismiss</button>
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="oracle-empty" style={{padding:14}}>No compliance flags.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
